import { useEffect, useState } from "react";
import { InputRadioProps } from "./InputRadio.type";

const INPUT_COLOR_ERROR = "red";

export default function InputRadio({
  fieldName,
  label,
  register,
  required,
  error,
  onChange,
  option1,
  option2,
  defaultValue,
  labelStyles = "",
  inputStyles = "",
  inputsContainerStyles = "",
  globalContainerStyles = "",
  value,
  getValues,
  readOnly,
}: InputRadioProps) {
  const [selected, setSelected] = useState( defaultValue || getValues?.(fieldName),);
  const option1Register = register(fieldName, {
    required,
  });
  const option2Register = register(fieldName, {
    required,
  });

  const handleInputRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
    onChange && onChange(e.target.value);
  };

  useEffect(() => {
    setSelected(defaultValue || getValues?.(fieldName));
  }, [defaultValue]);

  return (
    <>
      <div className={`w-full flex ${globalContainerStyles}`}>
        <label className={labelStyles}>{label}</label>
        <div className={`mr-3 ${inputsContainerStyles}`}>
          <label className={`sm:mx-3  ${inputStyles}`}>
            <input
              type="radio"
              disabled={readOnly}
              className="mx-1 text-red-500 sm:mx-3 focus:ring-red-300"
              {...option1Register}
              value={option1}
              checked={(value ?? selected) === option1 ? true : false}
              onChange={(e) => {
                option1Register.onChange(e);
                handleInputRadio(e);
              }}
            />
            {option1 ? option1 : undefined}
          </label>
          <label className={`sm:mx-3 ${inputStyles}`}>
            <input
              type="radio"
              disabled={readOnly}
              className="mx-1 text-red-500 sm:mx-3 focus:ring-red-300"
              {...option2Register}
              value={option2}
              checked={(value ?? selected) === option2 ? true : false}
              onChange={(e) => {
                option2Register.onChange(e);
                handleInputRadio(e);
              }}
            />
            {option2 ? option2 : undefined}
          </label>
        </div>
      </div>
      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>Campo Obligatorio*</span>
      )}
    </>
  );
}
